export default __webpack_public_path__ + "static/media/hero-background.c4eee1b1.jpeg";